import { c as _c } from "react/compiler-runtime";
import { Typography } from "../../atoms";
import { Channel } from "@/shared/types/type/review";
import { getChannelInitial, getChannelColor } from "@/shared/utils/review";
import { Icon } from "@/shared/ui/atoms";
interface ChannelIconProps {
  channel: Channel;
}
const ChannelIcon = t0 => {
  const $ = _c(13);
  const {
    channel
  } = t0;
  const checkedChannel = channel === Channel.REVIEW_BOOST;
  if (checkedChannel) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        "--width": 32,
        "--height": 32
      };
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="dynamic-size relative mr-[6px] flex items-center justify-center overflow-hidden" style={t1 as React.CSSProperties}><Icon src="/icons/revieworks-icon.png" alt="revieworks icon" fill={true} /></div>;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  let t1;
  if ($[2] !== channel) {
    t1 = getChannelColor(channel);
    $[2] = channel;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = {
      backgroundColor: t1,
      "--width": 32,
      "--height": 32
    };
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = t2 as React.CSSProperties;
  let t4;
  if ($[6] !== channel) {
    t4 = getChannelInitial(channel);
    $[6] = channel;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <Typography as="span" size={20} lineHeight="normal" className="text-white font-extrabold">{t4}</Typography>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <div className="dynamic-size mr-[6px] rounded-full flex items-center justify-center" style={t3}>{t5}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default ChannelIcon;